import { render, staticRenderFns } from "./ShadowBox.vue?vue&type=template&id=34cb1a66&scoped=true&"
import script from "./ShadowBox.vue?vue&type=script&lang=js&"
export * from "./ShadowBox.vue?vue&type=script&lang=js&"
import style0 from "./ShadowBox.vue?vue&type=style&index=0&id=34cb1a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb1a66",
  null
  
)

export default component.exports